import { render, staticRenderFns } from "./TagDialog.vue?vue&type=template&id=c8fa14c4&scoped=true&"
import script from "./TagDialog.vue?vue&type=script&lang=js&"
export * from "./TagDialog.vue?vue&type=script&lang=js&"
import style0 from "./TagDialog.vue?vue&type=style&index=0&id=c8fa14c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fa14c4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src904045295/src/ueyes-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8fa14c4')) {
      api.createRecord('c8fa14c4', component.options)
    } else {
      api.reload('c8fa14c4', component.options)
    }
    module.hot.accept("./TagDialog.vue?vue&type=template&id=c8fa14c4&scoped=true&", function () {
      api.rerender('c8fa14c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/TagDialog.vue"
export default component.exports